<template>
  <div>
    <TopHeader />
    <router-view />
    <FooterPage />
  </div>
</template>

<script>
import TopHeader from './pages/artpulse/TopHeader.vue'
import FooterPage from './pages/artpulse/FooterPage.vue'
export default {
  name: 'App',
  components: {
    TopHeader,
    FooterPage
  }
}
</script>
